import { Box, Button, Typography } from "@mui/material";
import { StyledProjects } from "./projects.styled";
import { ProjectCard } from "../../components/projectCard/projectCard";
import { Plus, PlusIcon } from "@phosphor-icons/react";
import { useContext, useEffect, useMemo, useState } from "react";
import { LanguageContext } from "../../globals/LanguageContext";
import { ProjectFilters } from "../../components/projectFilters/projectFilters";
import { FilterValues } from "../../models/global/FilterTypes";

import { DarkOverlay } from "../../components/darkOverlay/DarkOverlay";
import { ProjectForm } from "../../components/form/ProjectForm";
import { Project } from "../../models/Project";
import { useProject } from "../../stores/useProject";
import { useProfile } from "../../stores/useProfile";
import { getFilteredProjects } from "./projects.utils";

export const Projects = () => {
  const [darkOverlayOpened, setDarkOverlayOpened] = useState<boolean>(false);
  const [projects, setProjects] = useState<Project[]>([]);
  const { dictionary } = useContext(LanguageContext);
  const [filters, setFilters] = useState<FilterValues>({
    searchText: "",
    status: "No Filter",
    sortOrder: "desc",
    tags: [],
    year: "",
    month: "",
  });

  const { fetchProjects } = useProject();
  const { user } = useProfile();

  const filteredAndSortedProjects = useMemo(() => {
    const filtered = getFilteredProjects(projects, filters)
    console.log(filtered)
    return filtered;
  }, [filters, projects]);

  useEffect(() => {
    updateItems();
  }, [user]);

  const updateItems = () => {
    if (!user) return;
    fetchProjects(user).then((res) => {
      setProjects(res ? res : []);
    });
    setDarkOverlayOpened(false);
  };

  return (
    <StyledProjects>
      <DarkOverlay
        opened={darkOverlayOpened}
        component={
          <ProjectForm
            onSave={updateItems}
            project={undefined}
            projectList={projects}
          />
        }
        onClose={() => {
          setDarkOverlayOpened(false);
        }}
      />
      <Box className="header">
        <Typography variant="h1">{dictionary.pages.projects.title}</Typography>
        <Button
          variant="outlined"
          className="addBtn"
          onClick={() => setDarkOverlayOpened(true)}
        >
          <PlusIcon size={32} weight="bold" />
          {dictionary.pages.projects.buttons.add}
        </Button>
      </Box>
      <Box className="filters">
        <ProjectFilters
          filters={filters}
          onChange={(filters) => setFilters(filters)}
          projectList={projects}
        />
      </Box>
      <Box className="projectsWrapper">
        {filteredAndSortedProjects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </Box>
    </StyledProjects>
  );
};
